import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {resolveUserAndAccount} from '../helper/auth-resolve.helper';
import {IConnectivityCheckStore, ConnectivityCheckStore} from './connectivity-check.stores';

const trace = getAppTracer('connectivity-check.loader');

export async function connectivityCheckRouteLoader(args: LoaderFunctionArgs): Promise<IConnectivityCheckStore | void> {
    trace.info('Starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const {currentUser, accountData} = await resolveUserAndAccount();

    const store = new ConnectivityCheckStore(accountData, currentUser);
    trace.info('Completed successfully');
    return store;
}
